import { instance } from "./instance";

export const setClientIpv6Header = (ip) => {
  if (ip) {
    return (instance.defaults.headers.common["Client-Ipv6"] = `${ip}`);
  }
  return (instance.defaults.headers.common["Client-Ipv6"] = "");
};
